import { render, staticRenderFns } from "./APMsgIntenVs.vue?vue&type=template&id=5178faf9&scoped=true&"
import script from "./APMsgIntenVs.vue?vue&type=script&lang=js&"
export * from "./APMsgIntenVs.vue?vue&type=script&lang=js&"
import style0 from "./APMsgIntenVs.vue?vue&type=style&index=0&id=5178faf9&lang=less&scoped=true&"
import style1 from "./APMsgIntenVs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178faf9",
  null
  
)

component.options.__file = "APMsgIntenVs.vue"
export default component.exports